import React, { useState } from 'react'
import { Button } from 'antd'
import { ReactComponent as EditIcon } from '../../../asserts/icon/client/physical-assessment/ic_edit.svg'
import EditableText from './EditableText'
import styled from 'styled-components'

const FormattedText = styled.div`
  white-space: pre-wrap;
  word-wrap: break-word;
  font-family: Gilroy;
  font-size: 15px;
  color: rgba(112, 128, 142, 1);

  h1, h2, h3, h4, h5, h6 {
    margin: 1em 0 0.5em 0;
    font-weight: 600;
    color: #264382;
  }

  h4 {
    font-size: 16px;
  }

  p {
    margin-bottom: 1em;
  }

  ul, ol {
    margin: 0 0 1em 1.5em;
    padding: 0;
  }

  li {
    margin-bottom: 0.5em;
    line-height: 1.5;
  }

  strong {
    font-weight: bold;
  }

  em {
    font-style: italic;
  }

  blockquote {
    margin: 1em 0;
    padding-left: 1em;
    border-left: 3px solid #ccc;
    color: #666;
  }
`;

const CompactFormattedText = styled(FormattedText)`
  margin-top: 0.5em;
  margin-bottom: 1em;
`;

const StepItemWrapper = styled.div`
  position: relative;

  &.compact {
    margin-bottom: 1em;
    
    .top-section {
      gap: 8px;
      min-height: unset;
      padding: 0;
      
      .left-section {
        gap: 8px;
        
        .title {
          font-size: 12px;
          margin: 0;
        }
      }

      .ant-btn {
        position: absolute;
        top: 24px;
        right: 0;
      }
    }
    
    .editor-section {
      margin-left: 0;
    }
  }
`;

export default function StepItem({
  editabled,
  field,
  title,
  placeholder,
  icon,
  color,
  value,
  onChange,
  variant = 'default',
  className = '',
}) {
  const [editing, setEditing] = useState(false)
  
  return (
    <StepItemWrapper className={`step-item ${variant} ${className}`}>
      <div className='top-section'>
        <div className='left-section'>
          {variant === 'default' && icon}
          <div className='title' style={{ color }}>
            {title}
          </div>
        </div>

        {!editing && editabled && (
          <Button type='text' onClick={() => setEditing(true)}>
            <EditIcon className='icon' />
          </Button>
        )}
      </div>

      <EditableText
        className='editor-section'
        value={value}
        editing={editing}
        placeholder={editabled ? placeholder : ''}
        setEditing={setEditing}
        onSave={(text) => onChange(text, field)}
        renderDisplay={(text) => (
          variant === 'compact' ? (
            <CompactFormattedText 
              dangerouslySetInnerHTML={{ __html: text }}
            />
          ) : (
            <FormattedText 
              dangerouslySetInnerHTML={{ __html: text }}
            />
          )
        )}
      />
    </StepItemWrapper>
  )
}
